export var ECardHeight;
(function (ECardHeight) {
    ECardHeight["NORMAL"] = "NORMAL";
    ECardHeight["SQUARED"] = "SQUARED";
    ECardHeight["TICKER"] = "TICKER";
    ECardHeight["MATCH_ROW"] = "MATCH_ROW";
    ECardHeight["UNSET"] = "UNSET";
})(ECardHeight || (ECardHeight = {}));
